import { ResidentialPropertyForSaleListing } from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableRow } from '@unreserved-frontend-v2/ui/details-table/models'
import { useMemo } from 'react'
import { useAmenitiesRow } from './use-amenities-row'
import { useBuildRow } from './use-build-row'
import { useCondoFeeRow } from './use-condo-fee-row'
import { useCondoPoliciesRow } from './use-condo-policies-row'
import { useCondoRow } from './use-condo-row'
import { useEstimatedExpensesRow } from './use-estimated-expenses-row'
import { useHeatingCoolingRow } from './use-heating-cooling-row'
import { useLotRow } from './use-lot-row'
import { useMlsRow } from './use-mls-row'
import { useOwnershipRow } from './use-ownership-row'
import { useParkingRow } from './use-parking-row'
import { useSizeRow } from './use-size-row'
import { useTaxesRow } from './use-taxes-row'
import { useUtilitiesRow } from './use-utilities-row'

export const useData = (listing: ResidentialPropertyForSaleListing, isMobile = false) => {
  const sizeRow = useSizeRow(listing, isMobile)
  const parkingRow = useParkingRow(listing.propertyDetails)
  const amenitiesRow = useAmenitiesRow(listing)
  const lotRow = useLotRow(listing.propertyDetails)
  const condoRow = useCondoRow(listing.propertyDetails)
  const buildRow = useBuildRow(listing.propertyDetails)
  const heatingCoolingRow = useHeatingCoolingRow(listing.propertyDetails?.utilities)
  const utilitiesRow = useUtilitiesRow(listing.propertyDetails?.utilities)

  const ownershipRow = useOwnershipRow(listing.ownershipDetails)
  const condoPoliciesRow = useCondoPoliciesRow(listing)
  const taxesRow = useTaxesRow(listing.ownershipDetails?.propertyTax)
  const condoFee = useCondoFeeRow(listing.ownershipDetails)
  const estimatedExpenseRow = useEstimatedExpensesRow(listing.ownershipDetails)

  const mlsDetailsRow = useMlsRow(listing)

  const propertyDetailsRows: DetailsTableRow[] = useMemo(
    () =>
      [sizeRow, parkingRow, lotRow, condoRow, amenitiesRow, buildRow, heatingCoolingRow, utilitiesRow].filter(
        Boolean
      ) as DetailsTableRow[],
    [sizeRow, parkingRow, amenitiesRow, lotRow, condoRow, buildRow, heatingCoolingRow, utilitiesRow]
  )

  const ownershipDetailsRows: DetailsTableRow[] = useMemo(
    () =>
      [ownershipRow, condoPoliciesRow, taxesRow, condoFee, estimatedExpenseRow].filter(Boolean) as DetailsTableRow[],
    [ownershipRow, condoPoliciesRow, taxesRow, condoFee, estimatedExpenseRow]
  )

  const mlsDetailsRows: DetailsTableRow[] = useMemo(() => [mlsDetailsRow], [mlsDetailsRow])

  return useMemo(
    () => ({
      propertyDetailsRows,
      ownershipDetailsRows,
      mlsDetailsRows,
    }),
    [propertyDetailsRows, ownershipDetailsRows, mlsDetailsRows]
  )
}
